















import { defineComponent, reactive, ref } from '@vue/composition-api';

import ElTableComp from '@components/ElTableComp/index.vue';
import HelloWorld from '@components/HelloWorld.vue';
import VerifyCode from '@components/VerifyCode/index.vue';

import Pagination from '@components/Pagination/index.vue';

export default defineComponent({
  name: 'Example',
  components: {
    ElTableComp,
    HelloWorld,
    VerifyCode,
    Pagination,
  },
  setup() {
    const msg = ref('this is a message');

    const tableData = reactive({
      data:[{
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-08',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-06',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-07',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }], 
      column: [{
        key: 'date',
        label: '日期',
        width: '200',
      },
      {
        key: 'name',
        label: '姓名',
        width: '200',
      },
      {
        key: 'address',
        label: '地址',
        width: '200',
      },
      ]
    });

    const handleSelectionChange = (selection: any) => {
      console.log(selection);
    };

    return {
      msg,
      tableData,
      handleSelectionChange,
    };
  },
});
